"use client";

import { useTranslations } from "next-intl";
import { ToggleSwitch } from "@/components/ui/ToggleSwitch";
import { useStreetView } from "../useStreetView";

/**
 * Shows or hides the tenant's street-view layers.
 *
 * A single switch rather than a collapsible section: unlike the other tools it
 * has nothing to configure, so it sits in the panel as one row.
 */
export function StreetViewToggle() {
  const t = useTranslations("tools");
  const { isActive, toggle } = useStreetView();

  const label = t("displayStreetview");

  return (
    <div className="flex flex-col border-b border-black/10 pb-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-row items-center justify-center text-base font-bold">
          <span className="mr-4 flex h-8 w-8 items-center justify-center rounded-full border border-[#EEEEEE]">
            <i className="icon ic-material_ic_3d_rotation_24px text-base" />
          </span>
          {label}
        </div>

        <div className="flex h-6 w-11 items-center justify-end rounded-full">
          <ToggleSwitch isActive={isActive} onChange={toggle} label={label} />
        </div>
      </div>
    </div>
  );
}
